import { ObjectField, NoPointers, Float32Field, Int32Field, } from "@opendaw/lib-box";
export class NeonEnvelope extends ObjectField {
    static create(construct) {
        return new NeonEnvelope(construct);
    }
    constructor(construct) {
        super(construct);
    }
    get rate1() {
        return this.getField(1);
    }
    get rate2() {
        return this.getField(2);
    }
    get rate3() {
        return this.getField(3);
    }
    get rate4() {
        return this.getField(4);
    }
    get rate5() {
        return this.getField(5);
    }
    get rate6() {
        return this.getField(6);
    }
    get rate7() {
        return this.getField(7);
    }
    get rate8() {
        return this.getField(8);
    }
    get level1() {
        return this.getField(11);
    }
    get level2() {
        return this.getField(12);
    }
    get level3() {
        return this.getField(13);
    }
    get level4() {
        return this.getField(14);
    }
    get level5() {
        return this.getField(15);
    }
    get level6() {
        return this.getField(16);
    }
    get level7() {
        return this.getField(17);
    }
    get level8() {
        return this.getField(18);
    }
    get sustain() {
        return this.getField(20);
    }
    get end() {
        return this.getField(21);
    }
    initializeFields() {
        return {
            1: Float32Field.create({
                parent: this,
                fieldKey: 1,
                fieldName: "rate1",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: 0, max: 99, scaling: "linear" }, "", 0),
            2: Float32Field.create({
                parent: this,
                fieldKey: 2,
                fieldName: "rate2",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: 0, max: 99, scaling: "linear" }, "", 0),
            3: Float32Field.create({
                parent: this,
                fieldKey: 3,
                fieldName: "rate3",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: 0, max: 99, scaling: "linear" }, "", 0),
            4: Float32Field.create({
                parent: this,
                fieldKey: 4,
                fieldName: "rate4",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: 0, max: 99, scaling: "linear" }, "", 0),
            5: Float32Field.create({
                parent: this,
                fieldKey: 5,
                fieldName: "rate5",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: 0, max: 99, scaling: "linear" }, "", 0),
            6: Float32Field.create({
                parent: this,
                fieldKey: 6,
                fieldName: "rate6",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: 0, max: 99, scaling: "linear" }, "", 0),
            7: Float32Field.create({
                parent: this,
                fieldKey: 7,
                fieldName: "rate7",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: 0, max: 99, scaling: "linear" }, "", 0),
            8: Float32Field.create({
                parent: this,
                fieldKey: 8,
                fieldName: "rate8",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: 0, max: 99, scaling: "linear" }, "", 0),
            11: Float32Field.create({
                parent: this,
                fieldKey: 11,
                fieldName: "level1",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: 0, max: 99, scaling: "linear" }, "", 0),
            12: Float32Field.create({
                parent: this,
                fieldKey: 12,
                fieldName: "level2",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: 0, max: 99, scaling: "linear" }, "", 0),
            13: Float32Field.create({
                parent: this,
                fieldKey: 13,
                fieldName: "level3",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: 0, max: 99, scaling: "linear" }, "", 0),
            14: Float32Field.create({
                parent: this,
                fieldKey: 14,
                fieldName: "level4",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: 0, max: 99, scaling: "linear" }, "", 0),
            15: Float32Field.create({
                parent: this,
                fieldKey: 15,
                fieldName: "level5",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: 0, max: 99, scaling: "linear" }, "", 0),
            16: Float32Field.create({
                parent: this,
                fieldKey: 16,
                fieldName: "level6",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: 0, max: 99, scaling: "linear" }, "", 0),
            17: Float32Field.create({
                parent: this,
                fieldKey: 17,
                fieldName: "level7",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: 0, max: 99, scaling: "linear" }, "", 0),
            18: Float32Field.create({
                parent: this,
                fieldKey: 18,
                fieldName: "level8",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: 0, max: 99, scaling: "linear" }, "", 0),
            20: Int32Field.create({
                parent: this,
                fieldKey: 20,
                fieldName: "sustain",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: 0, max: 8 }, "", 0),
            21: Int32Field.create({
                parent: this,
                fieldKey: 21,
                fieldName: "end",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: 1, max: 8 }, "", 1),
        };
    }
}
